<template>
  <div class="flex items-center gap-3 rounded-lg border border-slate-200 bg-slate-50/50 px-4 py-3">
    <span class="text-3xl font-bold leading-none tabular-nums tracking-tight" :class="scoreClass">
      {{ percent }}%
    </span>
    <div class="flex min-w-0 flex-col gap-1">
      <span class="text-xs font-medium uppercase tracking-[0.08em] text-gray-500">Follow-through Rate</span>
      <div class="flex flex-wrap items-center gap-x-2.5 text-xs font-medium tabular-nums">
        <span class="text-green-700">{{ counts.done }} done</span>
        <span v-if="counts.in_progress" class="text-blue-700">{{ counts.in_progress }} in progress</span>
        <span v-if="counts.expired" class="text-red-700">{{ counts.expired }} expired</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { PipelineReviewStatus } from '@/api/entity_types/PipelineReview';

type Props = { reviews: { status: PipelineReviewStatus }[] };
const { reviews } = defineProps<Props>();

const counts = computed(() => ({
  done: reviews.filter(r => r.status === 'done').length,
  in_progress: reviews.filter(r => r.status === 'in_progress').length,
  expired: reviews.filter(r => r.status === 'expired').length,
}));

const percent = computed(() => (reviews.length === 0 ? 0 : Math.round((counts.value.done / reviews.length) * 100)));

const scoreClass = computed(() => {
  if (percent.value >= 80) return 'text-green-600';
  if (percent.value >= 50) return 'text-yellow-600';
  return 'text-red-600';
});
</script>
